export const REMOVE_CARD='REMOVE_CARD'
export const REMOVE_CARD_SUCCESS='REMOVE_CARD_SUCCESS'
export const REMOVE_CARD_ERROR='REMOVE_CARD_ERROR'

export const RemoveCard = (data) => ({
    type: REMOVE_CARD,
    payload: data
})